import React, { useState } from 'react';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import CircleButton from '../CircleButton';

const HydrantManufacturerRow = ({ hydrantManufacturer, onDelete }) => {
  const [startDelete, setStartDelete] = useState(false);
  return (
    <tr id={hydrantManufacturer.id}>
      <td>{hydrantManufacturer.name}</td>
      <td>{hydrantManufacturer.address}</td>
      <td>{hydrantManufacturer.city}</td>
      <td>{hydrantManufacturer.state}</td>
      <td>{hydrantManufacturer.phone}</td>
      <td>{hydrantManufacturer.email}</td>
      <td className="action-cell">
        <div className="list-actions">
          <Link to={`hydrantManufacturers/${hydrantManufacturer.id}/edit`}>
            <CircleButton icon={faEdit} type="primary" title="Edit" />
          </Link>
          <CircleButton icon={faTrashAlt} type="danger" title="Delete" onClick={() => setStartDelete(true)} />
        </div>
        {startDelete && (
          <div className="row-confirm">
            <div className="form-actions">
              <span>Are you sure you want to delete this record?</span>
              <button type="button" className="btn btn-primary" onClick={() => onDelete(hydrantManufacturer.id)}>Yes</button>
              <button type="button" className="btn btn-secondary" onClick={() => setStartDelete(false)}>No</button>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
};

export default HydrantManufacturerRow;
